import { useEffect, useState } from "react";
import ListItem from "./components/ListItem";
import CreateLanguage from "./modal/CreateLanguage";
import PaginationComponent from "../../components/PaginationComponent";
import "../Category/subdomain.css";
import withRoleBased from "../../utils/Functions/withRoleBased";
import useLanguageList from "../../utils/CustomHooks/useLanguageList";
import { sortArray } from "../../utils/Functions/filter";

function Country({ access }) {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const { languageList, loading, getLanguageList } = useLanguageList("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(languageList.length / pageSize);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);

  useEffect(() => {
    let req = {};
    if (search) req.language_name = search;
    getLanguageList(req);
  }, [count]);
  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row m-0 w-100">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Language </h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-md-end">
            {access.canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Create Language
              </button>
            )}
          </div>

          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-borderless ">
                <thead>
                  <tr>
                    <td className="col-sm-2">Language</td>
                    <td className="col-sm-2">ISO Short Code </td>
                    <td className="col-sm-2">Status </td>
                    {access.canEdit && <td className="col-sm-2">Action</td>}
                    <td className="col-sm-2">Language </td>
                  </tr>
                </thead>
                <tbody>
                  {!loading && languageList && languageList.length > 0 ? (
                    sortArray(languageList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <ListItem
                          item={x}
                          key={i}
                          index={i}
                          refresh={() => setCount((x) => x + 1)}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {languageList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
        <CreateLanguage
          isOpen={isOpen}
          setOpen={() => setIsOpen(false)}
          refresh={() => setCount((x) => x + 1)}
        />
      </div>
    </main>
  );
}
export default withRoleBased(Country, "tag");
